module.exports = __webpack_public_path__ + "static/media/md-phone-landscape.dd0357e5.svg";